//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Scroll from '../AreaCode/scroll.vue';
export default {
  inject: ['pwds'],
  data: function data() {
    return {
      selectIndex: 0
    };
  },
  computed: {
    multiple: function multiple() {
      return this.pwds.length > 1;
    },
    title: function title() {
      return this.multiple ? '选择口令' : '口令已复制';
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$refs.scroll && _this.$refs.scroll.refresh();
    }, 33);
  },
  methods: {
    changePwd: function changePwd(index) {
      this.$emit('changePwd', this.pwds[index]);
      this.selectIndex = index;
    }
  },
  components: {
    Scroll: Scroll
  }
};